import AcfAgent from "@/Components/Front/Blocks/Acf/AcfAgent";
import AcfFeatures from "@/Components/Front/Blocks/Acf/AcfFeatures";
import AcfFeaturesList from "@/Components/Front/Blocks/Acf/AcfFeaturesList";
import AcfImageWithContent from "@/Components/Front/Blocks/Acf/AcfImageWithContent";
import AcfSlider from "@/Components/Front/Blocks/Acf/AcfSlider";
import Skeleton from "@/Components/Preloaders/Skeleton";

const acfBlocksResolver = ({ block, id }) => {
    switch(block.name){
        case 'acf/image-with-content':
            return <AcfImageWithContent key={block.name+id} {...block.blockImageWithContent}/>
        break;
        case 'acf/features':
            return <AcfFeatures key={block.name+id} {...block.blockFeatures}/>
        break;
        case 'acf/features-list':
            return <AcfFeaturesList key={block.name+id} {...block.blockFeaturesList}/>
        break;
        case 'acf/slider':
            return <AcfSlider key={block.name+id} {...block.blockSlider}/>
        case 'acf/agent':
            return <AcfAgent key={block.name+id} {...block.blockAcfAgent}/>
        break;
    }
}

export default acfBlocksResolver;